module.exports = __webpack_public_path__ + "img/gt.8f888776.png";